import {
  adPlacementsModalSaveStart,
  adPlacementsModalSaveSuccess,
  adPlacementsModalSaveError,
} from "../actions/ad_placements_modal";
import episodeAPI from "../api/episodes";
import ActionManager from "./base";

class AdPlacementActionManager extends ActionManager {
  defaultErrorMessage() {
    return "Uh oh, something went wrong updating ad placements. Please try again later.";
  }

  defaultPreCallActionCreator() {
    return adPlacementsModalSaveStart;
  }

  defaultSuccessActionCreator() {
    return adPlacementsModalSaveSuccess;
  }

  defaultErrorActionCreator() {
    return adPlacementsModalSaveError;
  }

  execute() {
    return episodeAPI.updateEpisode(this.args.episode, this.args.authToken);
  }

  responseOK(dispatch, json) {
    super.responseOK(dispatch, json);
    this.showSuccess(dispatch, "Ad placements saved.");
  }

  // Same as above, but for 400's.
  response400(dispatch, json) {
    dispatch(adPlacementsModalSaveError("At least two placements are required."));
  }
}
export default AdPlacementActionManager;
